export enum CreditType {
  MINUS = 'MINUS',
  PERCENT = 'PERCENT',
}
